import blue from '@material-ui/core/colors/blue';
import green from '@material-ui/core/colors/green';
import orange from '@material-ui/core/colors/orange';
import yellow from '@material-ui/core/colors/yellow';
import red from '@material-ui/core/colors/red';

const rowStyle = (record, index, defaultStyle = {}) => {
    if (record && record.status === 'ATTENTE')
        return {
            ...defaultStyle,
            borderLeftColor: blue[500],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };
    
        if (record && record.status === 'ANNULER')
        return {
            ...defaultStyle,
            borderLeftColor: red[500],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };
    
 
    if (record && record.total_encaisse === 0)
        return {
            ...defaultStyle,
            borderLeftColor: orange[500],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };

    if (record && record.reste_a_payer > 0)
        return {
            ...defaultStyle,
            borderLeftColor: yellow[500],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };

      if (record && record.reste_a_payer === 0)
        return {
            ...defaultStyle,
            borderLeftColor: green[500],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };

    return defaultStyle;

};

export default rowStyle;